import { Fragment, useEffect, useRef, useState } from "react"
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { update, updateCaminhoesCaminhoeiros } from "../../redux/slicers/user"
import { getAllData, getStatusCarga, Unauthorized, updateTable, verificaTipoUsuario } from "../../services/Servicos"
import Loading from "../loading/Loading"

import './Modal.scss'


export default function ModalAtualizarCaminhoesCaminhoneiros({ msg, title, show, setShow, msgButton }) {

    const dispatch = useDispatch()
 

    const [loading, setLoading] = useState({
        isLoading: false,
        msg: msgButton,
        style:'primary'
    })

    const [cargasEmAberto, setCargasEmAberto] = useState([])
    const [loadingCargas, setLoadingCargas] = useState(false)


    const userS = useSelector(state => state.userSlice)
    const updateCaminhoesList = () => {
        getAllData(verificaTipoUsuario(userS) + 'caminhoes/caminhoneiros').then(response => {
            dispatch(updateCaminhoesCaminhoeiros(response.data))
            handlerSimpleClose()
        })
    }


    const submitDataExclude = async () => {
        if (loadingCargas) {
            return
        }

        const body = {
            id_caminhoneiro:'',
            nome_caminhoneiro:'',
            cpf_caminhoneiro:'',
            cnh_caminhoneiro:'',
            telefone_caminhoneiro:'',
            _caminhoneiro: '',
            tipo_operacao: 'EXCLUSÃO'
        }
            setLoading({
                isLoading: true,
                msg: 'Excluindo Atribuição',
                style:'danger'
            })
            await updateTable(verificaTipoUsuario(userS) + 'caminhoes/caminhoneiros', msg.msg.PLACA, body)
                .then(resp => {
                    setLoading({
                        isLoading: false,
                        msg: 'Excluido com Sucesso',
                        style:'success'
                    })
        
                    setTimeout(() => {
                        updateCaminhoesList()
                        window.location.reload()
                    }, 500)
                })
                .catch(error => {
                    if (error.msg === 'Unauthorized') {
                        Unauthorized(dispatch, update)
                    }
                })

                // const bodyLog = {
                //     placa: msg.msg.PLACA
                //     , cpf_caminhoneiro: msg.msg.CPF
                //     , tipo_operacao: 'EXCLUSÃO'
                // }
                // await insertLogCaminhoes(bodyLog, user.tipo)
                //     .then(resp => {
                
                //     })
                //     .catch(error => {
                //         if (error.msg === 'Unauthorized') {
                //             alert('Session has Expired')
                //             dispatch(update({ authenticated: false, token: '' }))
                //             return window.location.replace('/login')
                            
                //         }
                //         alert('Erro Inesperado')
                //         setLoading(last => ({
                //             ...last,
                //             flag: false,
                //             msg:'Error',
                //             style:'danger'
                //         }))
        
                //     })
    }

    const handlerSimpleClose = () => setShow(last => ({ error: { flag: false } }))

    useEffect(() => {
        const cpf = msg?.msg?.CPF

        if (!cpf || !show) {
            setCargasEmAberto([])
            setLoadingCargas(false)
            return
        }

        setLoadingCargas(true)
        getAllData("cargas/em-processamento", { logica: "lte", status: 12, caminhoneiro: cpf })
            .then(res => {
                const cargasData = Array.isArray(res.data) ? res.data : []
                setCargasEmAberto(cargasData)
            })
            .catch(() => {
                setCargasEmAberto([])
            })
            .finally(() => {
                setLoadingCargas(false)
            })
    }, [msg, show])

    return (
        <>
            <Modal
                show={show}
                onHide={handlerSimpleClose}
                backdrop='static'
                keyboard={false}
                centered
                size='md'
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title}: {msg.msg.pk}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ExcluirDados msg={msg}/>
                    <AvisoCargasEmAberto loading={loadingCargas} cargas={cargasEmAberto} />
                </Modal.Body>
                <Modal.Footer>
                    <Row style={{width:'100%'}}>
                        <Col>
                            <Button variant={loading.style} onClick={submitDataExclude} disabled={loading.isLoading || loadingCargas}>
                                {
                                    loadingCargas
                                        ? <Loading msg='Carregando cargas em aberto' />
                                        : (loading.isLoading ? <Loading msg={loading.msg} /> : loading.msg)
                                }
                                {loading.style === 'success' ? <i className="bi bi-check"></i>:""}
                                
                            </Button>
                        </Col>
                        <Col>
                            <Button variant='secondary' onClick={handlerSimpleClose}>Cancelar</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        </>
    )
}

function AvisoCargasEmAberto({ loading, cargas }) {
    const getCargaId = (carga) => carga?.pk ?? carga?.id ?? carga?.id_carga ?? '-'
    const getRota = (carga) => carga?.rota ?? carga?.ROTA ?? carga?.destino ?? '-'
    const getStatus = (carga) => {
        const statusCode = carga?.status ?? carga?.STATUS
        const saiuParaEntrega = carga?.saiu_para_entrega ?? carga?.SAIU_PARA_ENTREGA ?? false

        return getStatusCarga(statusCode, saiuParaEntrega) || statusCode || '-'
    }

    const cardStyle = {
        marginTop: 16,
        borderRadius: 14,
        border: '1px solid #dbe4ff',
        background: '#ffffff',
        boxShadow: '0 10px 22px rgba(41, 98, 255, 0.08)',
        padding: '18px 18px 14px'
    }

    const iconBoxStyle = {
        width: 48,
        height: 48,
        borderRadius: 12,
        border: '1px solid #2962ff',
        color: '#2962ff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',
        boxShadow: '0 6px 18px rgba(41, 98, 255, 0.2)',
        marginBottom: 14
    }

    const titleStyle = {
        fontSize: '1.2rem',
        fontWeight: 700,
        color: '#1f2a4d',
        marginBottom: 8
    }

    const textStyle = {
        color: '#5f6e92',
        lineHeight: 1.45,
        marginBottom: 10,
        fontSize: '0.95rem'
    }

    if (loading) {
        return (
            <div style={cardStyle}>
                <div style={titleStyle}>Verificando impacto da alteração</div>
                <div style={textStyle}>
                    Buscando cargas em aberto deste motorista...
                </div>
                <div style={{ color: '#2962ff', fontWeight: 600, fontSize: '0.9rem' }}>
                    Aguarde um instante
                </div>
            </div>
        )
    }

    if (!cargas?.length) {
        return null
    }

    return (
        <div>
            <div style={cardStyle}>
                <div style={titleStyle}>Impacto da remoção do motorista</div>
                <div style={textStyle}>
                    Ao confirmar, as cargas abaixo perderão a referência de motorista.
                </div>
                <div
                    className='table-responsive'
                    style={{
                        marginBottom: 10,
                        maxHeight: 240,
                        overflowY: 'auto',
                        border: '1px solid #e6ecff',
                        borderRadius: 8
                    }}
                >
                    <Table bordered hover size='sm' style={{ marginBottom: 0, background: '#f9fbff' }}>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Rota</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                cargas.map((carga, index) => (
                                    <tr key={carga?.pk || carga?.id || index}>
                                        <td>{getCargaId(carga)}</td>
                                        <td>{carga?.nome || getRota(carga)}</td>
                                        <td>{getStatus(carga)}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

function ExcluirDados({ msg }) {
    return (
        <Fragment>
            <div>
                {msg.title}
            </div>
            <div>
                {
                    Object
                        .keys(msg.msg)
                        .map((key, index) =>
                            <div key={index}>
                                {key}: <b><i>{msg.msg[key]}</i></b>
                            </div>
                        )
                }
            </div>
        </Fragment>
    )
}
